export type ChatMessage = { role: "user" | "assistant"; content: string };

type ChatHistoryItem = {
	type: "MESSAGE" | "EDIT_REQUEST";
	chat: string;
};

export const getSessionStorageKey = (workflowId: string) => `alpha-session:${workflowId}`;

export const mapChatHistoryItems = (items: ChatHistoryItem[]): ChatMessage[] =>
	items.map((item) => ({
		role: item.type === "MESSAGE" ? "user" : "assistant",
		content: item.chat,
	}));

export const ensureWelcomeMessage = (
	messages: ChatMessage[],
	welcomeMessage: string,
	legacyWelcomeMessage: string,
): ChatMessage[] => {
	const hasWelcome = messages.some(
		(item) =>
			item.role === "assistant" &&
			(item.content === welcomeMessage || item.content === legacyWelcomeMessage),
	);

	if (hasWelcome) {
		return messages;
	}

	return [{ role: "assistant", content: welcomeMessage }, ...messages];
};
